import { isProjectTransactionCompleted } from "@/api/api";
import type { ProjectTransactionNotification } from "@/types/api";
import type { ProjectDetailsProject } from "@/types/project";
import { completedMediaIdFromTransaction } from "@/services/applyCompletedGenerationTransaction";
import type { LibraryMediaHighlight } from "@/types/routes";

function entityGenerationCount(tagType: string, tagId: string, project: ProjectDetailsProject): number {
  if (tagType === "character") {
    const target = project.characters?.find((character) => character.id === tagId);
    return target?.images?.filter((id) => typeof id === "string" && id.trim() !== "").length ?? 0;
  }

  if (tagType === "location") {
    const target = project.locations?.find((location) => location.id === tagId);
    return target?.images?.filter((id) => typeof id === "string" && id.trim() !== "").length ?? 0;
  }

  if (tagType === "shot") {
    const target = project["storyboard-shots"]?.find((shot) => shot.id === tagId);
    return target?.images?.filter((id) => typeof id === "string" && id.trim() !== "").length ?? 0;
  }

  if (tagType === "video") {
    const target = project["storyboard-shots"]?.find((shot) => shot.id === tagId);
    return (target?.visuals ?? []).filter((visual) => visual.status === "completed").length;
  }

  return 0;
}

export function libraryHighlightForCompletedTransaction(
  transaction: ProjectTransactionNotification,
  project: ProjectDetailsProject | null | undefined
): LibraryMediaHighlight | null {
  if (!isProjectTransactionCompleted(transaction.transaction_status) || !project) {
    return null;
  }

  const tagId = transaction.tag_id?.trim();
  const tagType = transaction.tag_type?.trim().toLowerCase();
  if (!tagId || !tagType) {
    return null;
  }

  if (entityGenerationCount(tagType, tagId, project) <= 1) {
    return null;
  }

  const mediaId = completedMediaIdFromTransaction(transaction);
  if (!mediaId) {
    return null;
  }

  if (tagType === "video") {
    return { kind: "video", mediaId };
  }

  if (tagType === "character" || tagType === "location" || tagType === "shot") {
    return { kind: "image", mediaId };
  }

  return null;
}
